import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialProps {
  activeIndex: number | null;
  isEditing?: boolean;
  util?: string;
}

const initialState: InitialProps = {
  activeIndex: 1,
  isEditing: false,
  util: undefined,
};

const collectionSlice = createSlice({
  name: "collectionData",
  initialState,
  reducers: {
    onUpdateActiveIndex: (state, action: PayloadAction<number | null>) => {
      state.activeIndex = action.payload;
    },
    onUpdateIsEditing: (state, action: PayloadAction<boolean>) => {
      state.isEditing = action.payload;
    },
    onUpdateUtil: (state, action: PayloadAction<string | undefined>) => {
      state.util = action.payload;
    },
  },
});

export const { onUpdateActiveIndex, onUpdateIsEditing, onUpdateUtil } =
  collectionSlice.actions;

export default collectionSlice.reducer;
